
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3cat/documentals-i-reportatges",
      function () {
        return require("private-next-pages/3cat/documentals-i-reportatges/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3cat/documentals-i-reportatges"])
      });
    }
  